import { LinkBox, LinkOverlay, Icon } from '@chakra-ui/react'

export const MenuLink = (props) => {
  const { text, url, icon, isExternal = false, ...rest } = props

  return (
    <LinkBox p={rest.p} textAlign={rest.textAlign} width={'100%'}>
      <LinkOverlay fontSize={rest.fontSize} href={url} isExternal={isExternal}>
        {icon && <Icon as={icon} w="16px" h="16px" mr="4px" verticalAlign="middle" />}
        {text}
      </LinkOverlay>
    </LinkBox>
  )
}
